import * as React from "react";
export class FreeBet extends React.Component {
    renderText() {
        return (React.createElement("div", { className: "rj-freebet__wrapper" },
            React.createElement("div", { className: "rj-freebet__text", onClick: this.props.toggleStakeType }, this.props.text),
            React.createElement("div", { className: "rj-freebet__right-side" })));
    }
    render() {
        return (this.props.isActive && this.renderText());
    }
}
//# sourceMappingURL=FreeBet.js.map